import {
  GET_ALL_NEGOTIATION_CONTRACTS_FAILURE,
  GET_ALL_NEGOTIATION_CONTRACTS_SUCCESS,
  GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
  GET_DOCUMENT_OUTCOME,
  GET_DOCUMENT_OUTCOME_FAILURE,
  GET_DOCUMENT_OUTCOME_SUCCESS,
  GET_NEGOTIATION_TILE_DETAILS_FAILURE,
  GET_NEGOTIATION_TILE_DETAILS_SUCCESS,
  GET_REVIEW_NEGOTIATION_DATA_FAILURE,
  GET_REVIEW_NEGOTIATION_DATA_SUCCESS,
  RESET_DETAILED_NEGOTIATION_OVERVIEW,
  SET_CLOSE_NEGOTIATION_CONTRACT_DATA,
  SET_EXIT_STATUS_DETIALED_OVERVIEW,
  SET_IS_DATA_UPDATED,
  SET_NEGOTIATION_CONTRACT_STATUS,
} from "../Action/actionTypes";

interface InitialStateType {
  ReviewNegotiationData: object[],
  DocOutcomeData:any,
  negotiationData: object[];
  error: string;
  isNavigate: boolean;
  contractStatus: string;
  detailedOverviewData: object;
  isDataUpdated: boolean;
  isExited: boolean;
  closeNegotiaitionData:object
}
const initialState: InitialStateType = {
  negotiationData: [],
  ReviewNegotiationData: [],
  error: "",
  isNavigate: false,
  contractStatus: "",
  detailedOverviewData: {},
  DocOutcomeData:{},
  isDataUpdated: false,
  isExited: false,
  closeNegotiaitionData:{}
};

const DashboardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_NEGOTIATION_CONTRACTS_SUCCESS:
      return {
        ...state,
        negotiationData: action.payload,
      };
    case GET_ALL_NEGOTIATION_CONTRACTS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
      case GET_DOCUMENT_OUTCOME_SUCCESS:
            return {
              ...state,
              DocOutcomeData: action.payload,
              loading: false,
            };
          case GET_DOCUMENT_OUTCOME_FAILURE:
            return {
              ...state,
              error: action.payload,
              loading: false,
            };
            case GET_DOCUMENT_OUTCOME:
            return {
              ...state,
              loading: true,
              isLoaded: true,
            };
    case GET_REVIEW_NEGOTIATION_DATA_SUCCESS: return {
      ...state,
      ReviewNegotiationData: action.payload,
    }

    case GET_REVIEW_NEGOTIATION_DATA_FAILURE: return {
      ...state,
      error: action.payload,
    }
    case GET_NEGOTIATION_TILE_DETAILS_SUCCESS:
      return {
        ...state,
        isNavigate: true,
      };
    case GET_NEGOTIATION_TILE_DETAILS_FAILURE:
      return {
        ...state,
        isNavigate: false,
      };

    case SET_NEGOTIATION_CONTRACT_STATUS:
      return {
        ...state,
        contractStatus: action.payload,
      };

    case GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS:
      return {
        ...state,
        detailedOverviewData: action.payload,
      };

    case RESET_DETAILED_NEGOTIATION_OVERVIEW:
      return {
        ...state,
        ...initialState,
      };

    case SET_IS_DATA_UPDATED:
      return {
        ...state,
        isDataUpdated: action.payload,
      };

    case SET_EXIT_STATUS_DETIALED_OVERVIEW:
      return {
        ...state,
        isExited: action.payload,
      };

    case SET_CLOSE_NEGOTIATION_CONTRACT_DATA: return {
      ...state,
      closeNegotiaitionData:action.payload
    }
    default:
      return state;
  }
};

export default DashboardReducer;
